/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Breakpoint } from 'react-socks';

class FeedEditorTabs extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			orientationOverride: false
		};

		this.closeOrientation = this.closeOrientation.bind(this);

	}

	closeOrientation(e) {

		this.setState({
			orientationOverride: true
		});

	}

	render() {

		let constants = this.props.app.config.constants,
			socialTab = null,
			toolbar = null,
			config = null,
			orientation = null,
			feedTabClass = classnames('input-section',{
				'active': this.props.currentSection === 'feed' ? true : false,
				'complex': this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED ? true : false
			}),
			configTabClass = classnames('config-section', {
				'active': this.props.currentSection === 'config' ? true : false
			}),
			configIconClass = 'dlvr-icon feed-config',
			socialTabClass = classnames('social-section', {
				'active': this.props.currentSection === 'social' ? true : false,
				'complex': this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED ? true : false
			}),
			socialIcon = null,
			TypeIcon = null,
			typeIcon = null,
			step1Class = classnames('active', {
				'complete': (this.props.currentSection === 'config' || this.props.currentSection === 'social') ? true : false
			}),
			step2Class = classnames({
				'active': (this.props.currentSection === 'config' || this.props.currentSection === 'social') ? true : false,
				'complete': (this.props.currentSection === 'social') ? true : false
			}),
			step3Class = classnames({
				'active': (this.props.currentSection === 'social') ? true : false
			}),
			imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
			orientationList = null;

		if (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED) {
			step1Class = classnames('active', {
				'complete': (this.props.currentSection === 'social') ? true : false
			});
			step2Class = classnames({
				'active': (this.props.currentSection === 'social') ? true : false
			});
		}

		if (this.props.inputType === 'wordpress') {
			TypeIcon = IconFactory['wordpress'];
		} else {
			TypeIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.inputType)];
		}

		if (this.props.inputType === 0) {
			TypeIcon = IconFactory['search'];
		}

		if (feedTabClass.match('active')) {
			typeIcon = (
				<TypeIcon />
			);
		} else {
			typeIcon = (
				<TypeIcon alt="onboarding-inactive"/>
			);
		}

		if (!configTabClass.match('active')) {
			configIconClass += " onboarding-inactive";
		}

		if (socialTabClass.match('active')) {
			socialIcon = (
				<img width="20" height="20" style={{verticalAlign: 'middle'}} src={imageUrl + 'misc/socials-active.png'}/>
			);
		} else {
			socialIcon = (
				<img width="20" height="20" style={{verticalAlign: 'middle'}} src={imageUrl + 'misc/socials-inactive.png'}/>
			);
		}

		if (this.props.showSocial) {
			if (this.props.app.flags.routeViewType != constants.ROUTE_VIEW_ADVANCED) {
				config = (
					<div className={configTabClass}>
						<span className="va-helper"></span>
						<div className="dlvr-icon-wrapper">
							<div className={configIconClass}>
								<i className="icon ion-paper-airplane"></i>
							</div>
						</div>
						<span className="row-label">
							<Breakpoint desktop only>
								Post Settings
							</Breakpoint>
							<Breakpoint mobile only>
								Settings
							</Breakpoint>
						</span>
					</div>
				);
			}
			socialTab = (
				<div className={socialTabClass}>
					<span className="va-helper"></span>
					<div className="dlvr-icon-wrapper">
						{socialIcon}
					</div>
					<span className="row-label">
						<Breakpoint desktop only>
							Connect Socials
						</Breakpoint>
						<Breakpoint mobile only>
							Socials
						</Breakpoint>
					</span>
				</div>
		   	);
		}

		if (this.props.showOrientation && this.state.orientationOverride === false) {
			if (this.props.feedType === 'automated' ) {
				// if (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_SIMPLE) {
				// 	orientationList = (
				// 		<ol className="orientation-list">
				// 			<li className={step1Class}>Connect a blog, site, or feed.</li>
				// 			<li className={step2Class}>Tell us when you want dlvr.it to post.</li>
				// 			<li className={step3Class}>Connect your social profiles.</li>
				// 		</ol>
				// 	);
				// 	orientation = (
				// 		<div className="detail-status info orientation">
				// 			<div className="orientation-close" onClick={this.closeOrientation}>
				// 				<i className="fa fa-times-circle"></i>
				// 			</div>
				// 			<h2 className="orientation-heading">Automatically post to your social profiles.</h2>
				// 			{orientationList}
				// 		</div>
				// 	);
				// } else {
				// 	orientation = (
				// 		<div className="detail-status info orientation">
				// 			<div className="orientation-close" onClick={this.closeOrientation}>
				// 				<i className="fa fa-times-circle"></i>
				// 			</div>
				// 			<h2 className="orientation-heading">Automatically post to your social profiles.</h2>
				// 		</div>
				// 	);
				// }
			} else if (this.props.feedType === 'curated') {
				orientation = (
					<div className="detail-status info orientation">
						<div className="orientation-close" onClick={this.closeOrientation} role="button" aria-label="close">
							<i className="fa fa-times-circle"></i>
						</div>
						<h2 className="orientation-heading">Get started with Curation</h2>
						<ol className="orientation-list">
							<li className={step1Class}>Find a feed or site with content
								relevant to your social media audience.</li>
							<li className={step2Class}>Select content to share now or queue up to share later.</li>
						</ol>
					</div>
				);
			}
		}

		if(this.props.feedLabel && this.props.feedLabel !== 'none') {
			toolbar = (
				<div className="editor-breadcrumbs">
					<div className="route-list-row">
						<div className={feedTabClass}>
							<span className="va-helper"></span>
							{typeIcon}
							<div className="input-section-label">
								<span className="va-helper"></span>
								<span className="row-label">
									<Breakpoint desktop only>
										{this.props.feedLabel}
									</Breakpoint>
									<Breakpoint mobile only>
										Source
									</Breakpoint>
								</span>
							</div>
				   		</div>
						{config}
						{socialTab}
					</div>
			  </div>
			);
		}

		return (
			<div>
				{orientation}
				{toolbar}
		  	</div>
		);
	}

};

FeedEditorTabs.displayName = "FeedEditorTabs";

FeedEditorTabs.propTypes = {
	inputType: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	feedLabel: PropTypes.string,
	showSocial: PropTypes.bool,
	showOrientation: PropTypes.bool,
	currentSection: PropTypes.string,
	feedType: PropTypes.string
};

FeedEditorTabs.defaultProps = {
	inputType: 100, // INPUT_TYPE_FEED
	feedLabel: 'Choose source',
	showSocial: true,
	showOrientation: false,
	currentSection: 'feed',
	feedType: 'automated'
};

export default FeedEditorTabs;
